module.exports = __webpack_public_path__ + "static/media/02-1-galeria-04-messika@2x.66648103.jpg";